import mockedPaginatedResponse from './mockedPaginatedResponse';
import mockedRequester from './mockedRequester';
export const mockedSeed = {
    id: 1,
    isDefault: false,
    vendor: 'Foo',
    name: 'Bar',
    localizedName: 'Bar',
    rpgCode: '9',
    rpgSubcode: '89',
    refWeenat: '12',
    isPerennial: false,
    cropUsage: 0,
    version: 0,
    isMaizyCompatible: false
};
const mock = {
    get: mockedRequester(mockedSeed, 'seeds.get'),
    getAll: mockedRequester([mockedSeed], 'seeds.getAll'),
    getMany: mockedRequester(mockedPaginatedResponse([mockedSeed]), 'seeds.getMany')
};
export default mock;
